module.exports = __webpack_public_path__ + "static/what-youll-get-a7d90f0fb13b2bc336df2a8c531c04fa.png";